import { render } from "./ResolutionSelect.vue?vue&type=template&id=08fe25fe"
import script from "./ResolutionSelect.vue?vue&type=script&lang=js"
export * from "./ResolutionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__